<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button autoHide="false"></ion-menu-button>
      <ion-back-button text="" icon="chevron-back"></ion-back-button>
    </ion-buttons>
    <ion-title>Payout Methods</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-item>
    <ion-label position="stacked">Receiving method</ion-label>
    <ion-select [(ngModel)]="metodoSelecionado" interface="action-sheet">
      <ion-select-option value="Zelle">Zelle</ion-select-option>
      <ion-select-option value="ContaBancaria">Bank Account (US)</ion-select-option>
      <ion-select-option value="ContaInternacional">International Account</ion-select-option>
    </ion-select>
  </ion-item>

  <ng-container *ngIf="metodoSelecionado === 'Zelle'">
    <ion-item>
      <ion-label position="stacked">Full name</ion-label>
      <ion-input [(ngModel)]="zelleNome" placeholder="Account holder name"></ion-input>
    </ion-item>
    <ion-item>
      <ion-label position="stacked">Email or phone</ion-label>
      <ion-input [(ngModel)]="zelleEmailOrPhone" placeholder="zelle@example.com or +1..."></ion-input>
    </ion-item>
    <ion-item>
      <ion-label position="stacked">Bank name (optional)</ion-label>
      <ion-input [(ngModel)]="zelleBanco" placeholder="e.g. Chase"></ion-input>
    </ion-item>
  </ng-container>

  <ng-container *ngIf="metodoSelecionado !== 'Zelle'">
    <p class="hint">Bank account configuration uses the same fields as the driver app — please contact support to register a bank-account method.</p>
  </ng-container>

  <ion-item>
    <ion-label position="stacked">SSN (optional)</ion-label>
    <ion-input [(ngModel)]="ssn" type="text" placeholder="For tax reporting"></ion-input>
  </ion-item>
  <ion-item>
    <ion-label position="stacked">Tax ID (optional)</ion-label>
    <ion-input [(ngModel)]="taxId" type="text"></ion-input>
  </ion-item>

  <div class="actions">
    <ion-button expand="block" color="primary" (click)="save()">
      <ion-icon name="save-outline" slot="start"></ion-icon>
      {{ current?.id ? 'Update' : 'Register' }} method
    </ion-button>
    <ion-button *ngIf="current?.id" expand="block" fill="outline" color="danger" (click)="deleteMethod()">
      <ion-icon name="trash-outline" slot="start"></ion-icon>
      Delete method
    </ion-button>
  </div>
</ion-content>
